import { styled } from '@mui/material';
import { m } from 'framer-motion';
import { Iconify } from 'src/components/iconify';

const variants = {
  hidden: {
    opacity: 0,
    scale: 0,
    y: 20,
    transition: {
      duration: 0.2,
      ease: 'easeOut',
    },
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: 'spring',
      stiffness: 260,
      damping: 20,
    },
  },
};

export const ConversationGoToBottom = ({
  isAtBottom,
  onClick,
}: { isAtBottom: boolean; onClick: () => void }) => {
  return (
    <StyledGoToBottom
      variants={variants}
      initial="hidden"
      animate={isAtBottom ? 'hidden' : 'visible'}
      onClick={onClick}
    >
      <Iconify icon="mdi:arrow-down" />
    </StyledGoToBottom>
  );
};

const StyledGoToBottom = styled(m.div)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(8),
  right: theme.spacing(2),
  color: theme.palette.common.white,
  backgroundColor: theme.palette.secondary.main,
  borderRadius: '50%',
  width: theme.spacing(5),
  height: theme.spacing(5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    backgroundColor: theme.palette.secondary.dark,
  },
  cursor: 'pointer',
}));
